import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { FormCard } from '@/components/PageLayout';
import PhoneMaskInput from '@/components/PhoneMaskInput';
import { useSettings, useUpdateSettings } from '@/hooks/useSettingsQueries';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const CardWrapper = styled.div`
  max-width: 480px;
  width: 100%;
`;

const CardTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px;
  color: #1a1a1a;
`;

export const ContactsSettingsPage: React.FC = () => {
  const [form] = Form.useForm();
  const { data: settings } = useSettings();
  const { mutate: updateSettings, isPending } = useUpdateSettings();

  useEffect(() => {
    if (settings) {
      form.setFieldsValue(settings);
    }
  }, [settings, form]);

  return (
    <PageWrapper>
      <CardWrapper>
        <FormCard>
          <CardTitle>Контакти та соцмережі</CardTitle>
          <Form form={form} layout="vertical" onFinish={(values) => updateSettings(values)}>
            <Form.Item
              name="phone"
              label="Телефон"
              rules={[{ required: true, message: 'Будь ласка, введіть телефон' }]}
            >
              <PhoneMaskInput />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Будь ласка, введіть email' },
                { type: 'email', message: 'Введіть коректний email' },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="workingHours" label="Години роботи">
              <Input />
            </Form.Item>
            <Form.Item name="instagramUrl" label="Instagram">
              <Input placeholder="https://instagram.com/..." />
            </Form.Item>
            <Form.Item name="facebookUrl" label="Facebook">
              <Input placeholder="https://facebook.com/..." />
            </Form.Item>
            <Form.Item name="telegramUrl" label="Telegram">
              <Input placeholder="https://t.me/..." />
            </Form.Item>
            <Form.Item name="tiktokUrl" label="TikTok">
              <Input placeholder="https://tiktok.com/@..." />
            </Form.Item>
            <Form.Item name="youtubeUrl" label="YouTube">
              <Input placeholder="https://youtube.com/..." />
            </Form.Item>
            <Form.Item name="viberUrl" label="Viber">
              <Input placeholder="viber://..." />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isPending}>
                Зберегти
              </Button>
            </Form.Item>
          </Form>
        </FormCard>
      </CardWrapper>
    </PageWrapper>
  );
};
